<template>
  <section class="about-chapter-4">
    <div class="about-chapter-4-content">
      <AboutAnchorNav :section="4" />

      <v-container class="px-sm-8 py-0 pa-md-0">
        <v-row align="start" justify="space-between" no-gutters>
          <v-col cols="12" md="3">
            <p class="text-section text--fes-magenta mb-4 mb-md-0">
              References and further reading
            </p>
          </v-col>

          <v-col cols="12" md="8">
            <p class="text-body text--fes-blue mb-0">
              Learn more about social-ecological transformation in Asia’s cities in the <router-link :to="'/references'">
              reference section</router-link>.
            </p>                    
          </v-col>
        </v-row>
      </v-container>       
    </div>
  </section>  
</template>

<script>
import AboutAnchorNav from '@/components/layout/AboutAnchorNav'

export default {
  name: 'AboutChapter5',
  components: {
    AboutAnchorNav,
  },
}
</script>

<style lang="scss" scoped>
.about-chapter-4 {
  scroll-margin-top: 70px;
}

.about-chapter-4-content {
  padding: 96px 0;
  background: #ECF6F9;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 48px 4px;
  }
}

</style>